import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Prospectos',
        icon: 'bx-user-circle',
        subItems: [
            {
                id: 2,
                label: 'Listado',
                link: '/prospect/list',
                parentId: 1
            }
        ]
    }
];

